import { useEffect, useState } from "react";

//MUI
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { useNavigate } from "react-router-dom";
import StepContent from "@mui/material/StepContent";
import { styled } from "@mui/material/styles";
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import Typography from "@mui/material/Typography";

//icons
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

//components
import AIBreadCrumbs from "../Common/AIBreadCrumbs";
import CustomButton from "../Common/CustomButton";

//apis
import { getTimelineList, getEventDetails, getTimelineDetail } from "../../apis/events.js";

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  background: "#F6FAFE",
  "& .left_container": {
    width: "100%",
    borderRight: "none",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflowY: "visible",
    overflowX: "hidden",
    padding: "1rem 0",
    background: "transparent",

    "& .headers": {
      width: "80%",
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "1rem",
      "& .event_title": {
        width: "90%",
        color: "#16346fff",
        fontSize: "19px",
        fontWeight: "600",
        display: "flex",
      },
      // "& .btn_style": {
      //   background: "#253A6A",
      //   color: "#FFFFFF",
      //   borderRadius: "5px",
      //   padding: "5px 10px",

      // }
    },
    "& .info_container": {
      width: "80%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: "1.5rem",
      "& .img_container": {
        width: "80%",
        display: "flex",
        justifyContent: "center",
        "& .img_style": {
          width: "100%",
          height: "290px",
          objectFit: "fill",
          objectPosition: "center",
          borderRadius: "8px",
        },
      },
      "& .description": {
        fontfamily: "Roboto",
        width: "80%",
        textAlign: "justify",
      },
      "& .subheading_text": {
        fontWeight: "bold",
        fontSize: "18px",
        marginTop: "12px"
      },
      "& .src_tags": {
        width: "80%",
        display: "flex",
        flexDirection: "column",
        alignItems: "felx-start",
        gap: "0.5rem",
        marginTop: "0.5rem",
        "& .tags_container": {
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          gap: "0.5rem",
          "& .tags_heading": {
            color: "#1B1C1E",
            fontSize: "15px",
            fontWeight: "400",
          },
          "& .tags_block": {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            gap: "0.5rem",
            "& .tag_item": {
              background: "#ECF0FC",
              color: "#253A6A",
              fontSize: "12px",
              fontWeight: "400",
              padding: "3px 10px",
              borderRadius: "3px",
            },
          },
        },
      },
    },
    "& .timeline_section": {
      width: "65%",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      background: "#FFFFFF",
      padding: "1rem",
      marginTop: "1rem",
      borderRadius: "8px",
      color: "black",

      "& .view_more_wrapper": {
        display: "flex",
        justifyContent: "center",
        margin: "1rem 0",
      },

      "& .view_more_btn": {
        padding: "10px 32px ",
        border: "none",
        borderRadius: "8px",
        backgroundColor: "#16346fff",
        color: "#fff",
        fontSize: "14px",
        fontWeight: "600",
        cursor: "pointer",
        transition: "background 0.3s",
        "&:hover": {
          backgroundColor: "#1976d2",
        },
      },

      "& .MuiStepLabel-root": {
        alignItems: "center",
      },
      "& .timeline_heading": {
        fontSize: "20px",
        fontWeight: "600",
        color: "#052564",
        marginBottom: "0.5rem",
      },
      "& .MuiStepLabel-label": {
        fontSize: "14px",
        fontWeight: "500",
        color: "#6B7280",
      },
      "& .timeline_item": {
        padding: "0.5rem 0",
      },
      "& .timeline_date": {
        fontSize: "14px",
        fontWeight: "500",
        color: "#6B7280",
        marginBottom: "0.1rem",
        marginLeft: "10px",
      },
      "& .MuiStepContent-root": {
        marginTop: "0rem",
        marginBottom: "1rem",
        paddingLeft: "1.5rem",
        color: "#000000",
        "& .timeline_title": {
          fontfamily: "Roboto",
          fontSize: "16px",
          fontWeight: "600",
          color: "#000000",
          textAlign: "justify",
          marginBottom: "0.8rem",
        },
        "& .timeline_desc": {
          fontfamily: "Roboto",
          fontSize: "14px",
          fontWeight: "400",
          color: "#374151",
          lineHeight: "1.5",
          textAlign: "justify",
          marginBottom: "0.5rem",
        },
      },
      "& .timeline_divider": {
        border: "none",
        borderBottom: "1px solid #B0B0B0",
        marginTop: "1rem",
        marginBottom: "0rem ",
        alignSelf: "stretch",
      },
    },

    "& .references_section": {
      marginTop: "40px",
      width: "65%",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      background: "#FFFFFF",
      padding: "1rem",
      borderRadius: "8px",
      color: "black",

      "& .references_heading": {
        fontSize: "20px",
        fontWeight: "600",
        color: "#052564",
        marginBottom: "0.5rem",
      },

      "& .references_grid": {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        columnGap: "20px",
        rowGap: "12px",
      },

      "& .reference_item": {
        display: "flex",
        alignItems: "flex-start",
        gap: "9px",
        background: " #E6EDF5",
        padding: "6px",
        borderRadius: "3px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        marginBottom: "2px",
        minHeight: "100px",
      },
      "& .reference_img": {
        width: "171px",
        height: "auto",
        maxHeight: "124px",
        objectFit: "cover",
        borderRadius: "4px",
        backgroundColor: "black",
        flexShrink: 0,
        aspectRatio: "171 / 124",
        alignSelf: "flex-start",
      },

      "& .reference_content": {
        display: "flex",
        flexDirection: "column",
        fontSize: "2px",
      },
      "& .reference_meta": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "4px",
      },

      "& .reference_title": {
        fontSize: "24px",
        fontWeight: "500",
        marginBottom: "4px",
        lineHeight: "1.3",
        fontfamily: "Roboto",
        fontstyle: "normal",
      },

      "& .reference_icon": {
        width: "16px",
        height: "16px",
        borderRadius: "50%",
        marginRight: "4px",
      },

      "& .reference_source": {
        fontSize: "12px",
        color: "#555",
        display: "flex",
        alignItems: "center",
        gap: "4px",
      },

      "& .reference_date": {
        fontSize: "12px",
        color: "#777",
        display: "flex",
        alignItems: "center",
        gap: "4px",
      },
    },

  },
}));

const IndividualEventDetails = ({ eventId }) => {
  const [selectedEvent, setSelectedEvent] = useState("");
  const [activeStep, setActiveStep] = useState(-1);
  const [timelineData, setTimelineData] = useState([]);
  const navigate = useNavigate();
  const [showAllTimeline, setShowAllTimeline] = useState(false);
  const [showAllRefs, setShowAllRefs] = useState(false);


  const handleTimelineClick = async (timeline) => {
    try {
      const { data, error } = await getTimelineDetail(timeline.id, selectedEvent.root_id);
      if (error) {
        console.error(error);
        return;
      }
      setSelectedEvent(data);
      setTimelineData(data.events || []);
      const index = data.events?.findIndex(ev => ev.id === timeline.id) || 0;
      setActiveStep(index);

      navigate(`/app/explore_ai/timeline/${timeline.id}/${selectedEvent.root_id}`);
    } catch (err) {
      console.error("Error fetching timeline details:", err);
    }
  };

  useEffect(() => {
    async function fetchEvent() {
      try {
        const { data, error } = await getEventDetails(eventId);
        if (data) {
          setSelectedEvent(data);
        }
        if (error) console.error(error);
      } catch (err) {
        console.error("Error fetching event details:", err);
      }
    }
    fetchEvent();
  }, [eventId]);


  useEffect(() => {
    const fetchTimeline = async () => {
      if (!selectedEvent?.root_id) return;
      const { data } = await getTimelineList(selectedEvent.root_id);
      setTimelineData(data || []);
    };
    fetchTimeline();
  }, [selectedEvent?.root_id]);


  const event = selectedEvent;
  if (!event) return <div>Loading...</div>;

  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.vertical}`]: {
      margin: 0,
      padding: 0,
    },
    [`& .${stepConnectorClasses.line}`]: {
      borderLeft: "2px solid #0a0a0aff",
      marginLeft: "15px",
      minHeight: "100%",
    },
  }));


  const CustomStepIcon = ({ active, completed }) => {
    const isCompleted = completed;
    return (
      <div
        style={{
          width: "14px",
          height: "14px",
          borderRadius: "50%",
          border: `1px solid ${isCompleted ? "#253A6A" : "#000"}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "8px",
          zIndex: 1,
          position: "relative",
        }}
      >
        {isCompleted && (
          <div
            style={{
              width: "9px",
              height: "9px",
              borderRadius: "50%",
              backgroundColor: "#253A6A",
            }}
          />
        )}
      </div>
    );
  };

  return (
    <Container>
      <div className="left_container">
        <AIBreadCrumbs />

        {/* Title */}
        <div className="headers">
          <Typography className="event_title">Title: {event.title}</Typography>
          {/* <CustomButton
            startIcon={<AddCircleOutlineIcon />}
            variant="contained"
            className="btn_style"
          >
            Create Task
          </CustomButton> */}
        </div>

        <div className="info_container">

          {/* Image */}
          <div className="img_container">
            <img
              src={event?.top_images?.[0]}
              alt={event?.title}
              className="img_style"
            />
          </div>

          {/* Description */}
          <div className="description">
            {event?.summary_details?.length > 0 ? (
              event.summary_details.map((section, idx) => (
                <div key={idx} className="summary_section">
                  <Typography className="subheading_text">
                    {section.subheading}
                  </Typography>

                  {section.bullets?.map((bullet, bIdx) => (
                    <Typography key={bIdx} className="bullet_text">
                      • {bullet.text}
                    </Typography>
                  ))}

                  {section.source_url?.length > 0 && (
                    <a
                      href={section.source_url[0]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="source_link"
                    >
                    </a>
                  )}
                </div>
              ))
            ) : (
              <Typography className="bullet_text">No summary available</Typography>
            )}
          </div>

          {/* Tags section */}
          <div className="src_tags">
            <div className="tags_container">
              <Typography className="tags_heading">Tags:</Typography>
              <div className="tags_block">
                {/* Location */}
                {event?.tags?.loc_ind
                  ?.sort((a, b) => b.importance - a.importance)
                  .slice(0, 2)
                  .map((tag, idx) => (
                    <div key={`loc-${idx}`} className="tag_item">
                      {tag.name}
                    </div>
                  ))}

                {/* Organization */}
                {event?.tags?.org_political_ind
                  ?.sort((a, b) => b.importance - a.importance)
                  .slice(0, 2)
                  .map((tag, idx) => (
                    <div key={`org-${idx}`} className="tag_item">
                      {tag.name}
                    </div>
                  ))}

                {/* Person */}
                {event?.tags?.person_political_ind
                  ?.sort((a, b) => b.importance - a.importance)
                  .slice(0, 2)
                  .map((tag, idx) => (
                    <div key={`person-${idx}`} className="tag_item">
                      {tag.name}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>


        {/* Timeline section */}
        <div className="timeline_section">
          <Typography className="timeline_heading">Timeline</Typography>
          <Stepper orientation="vertical" nonLinear activeStep={activeStep} connector={<CustomConnector />}>
            {(timelineData
              ?.slice()
              .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
              .slice(0, showAllTimeline ? timelineData.length : 4)
            ).map((item, index) => (
              <Step
                key={index}
                expanded
                completed={index < 1}
                onClick={() => handleTimelineClick(item)}
                style={{ cursor: "pointer" }}
              >
                <StepLabel StepIconComponent={CustomStepIcon}>
                  <Typography className="timeline_date">
                    {new Date(item.updated_at).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </Typography>
                </StepLabel>
                <StepContent TransitionProps={{ unmountOnExit: false }}>
                  <Typography className="timeline_title">{item.title}</Typography>
                  <Typography className="timeline_desc">{item.summary}</Typography>
                  <div className="timeline_divider" />
                </StepContent>
              </Step>
            ))}

            {/* View More button */}
            {!showAllTimeline && timelineData?.length > 4 && (
              <div className="view_more_wrapper">
                <button
                  className="view_more_btn"
                  onClick={() => setShowAllTimeline(true)}
                >
                  View More
                </button>
              </div>
            )}
          </Stepper>
        </div>

        {/* References Section */}
        <div className="references_section">
          <Typography className="references_heading">References</Typography>

          <div className="references_grid">
            {event?.sources?.length > 0 ? (
              event.sources
                .slice(0, showAllRefs ? event.sources.length : 4)
                .map((src, index) => (
                  <a
                    key={index}
                    href={src}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="reference_item"
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    <img
                      src={event.top_images?.[0] || ""}
                      alt={`Reference ${index + 1}`}
                      className="reference_img"
                    />
                    <div className="reference_content">
                      <Typography className="reference_title">{event.title}</Typography>
                      <div className="reference_meta">
                        <Typography className="reference_source">
                          {src && (
                            <>
                              <img
                                src={`https://www.google.com/s2/favicons?sz=32&domain_url=${new URL(src).hostname}`}
                                alt={new URL(src).hostname}
                                className="reference_icon"
                              />
                              {new URL(src).hostname}
                            </>
                          )}
                        </Typography>
                      </div>
                    </div>
                  </a>
                ))
            ) : (
              <Typography>No references available</Typography>
            )}
          </div>

          {/* View More button */}
          {!showAllRefs && event?.sources?.length > 4 && (
            <div className="view_more_wrapper">
              <button
                className="view_more_btn"
                onClick={() => setShowAllRefs(true)}
              >
                View More
              </button>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
}

export default IndividualEventDetails;